import { type Logger } from '@datadog/browser-logs/cjs/domain/logger';

export function setupErrorHandlers(logger: Logger | undefined) {
  // Handle synchronous errors
  window.addEventListener('error', (event: ErrorEvent) => {
    if (logger) {
      logger?.error('Unhandled synchronous error', {
        type: 'uncaughtError',
        message: event.message,
        stack: event.error?.stack,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        timestamp: new Date().toISOString()
      });
    } else {
      // eslint-disable-next-line no-console
      console.error(`=== UNCAUGHT ERROR (SYNC) ===
        Message: ${event.message}
        Filename: ${event.filename}
        Line: ${event.lineno}
        Column: ${event.colno}
        Stack: ${event.error?.stack}
      `);
    }
  });

  // Handle unhandled promise rejections
  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      const reason = event.reason;

      let message: string;
      let stack: string | undefined;

      if (reason === undefined || reason === null) {
        message = `Promise rejected with ${reason}`;
        stack = new Error(message).stack;
      } else if (reason instanceof Error) {
        message = reason.message;
        stack = reason.stack;
      } else if (typeof reason === 'string') {
        message = reason;
        stack = new Error(reason).stack;
      } else {
        message = JSON.stringify(reason);
        stack = new Error(message).stack;
      }

      if (logger) {
        logger?.error('Unhandled synchronous error', {
          type: 'unhandledRejection',
          message,
          stack,
          reasonType: typeof reason,
          timestamp: new Date().toISOString()
        });
      } else {
        // eslint-disable-next-line no-console
        console.error(`=== UNHANDLED PROMISE REJECTION ===
        Message: ${message}
        Stack: ${stack}
      `);
      }
    }
  );
}
